import { Component, ElementRef, Input, OnInit, Output, ViewChild, EventEmitter, inject } from '@angular/core';
import { Router } from '@angular/router';
import { UntypedFormBuilder, UntypedFormGroup } from '@angular/forms';

import { SvgLibraryIcon } from '@finnairoyj/fcom-ui-styles';

import { LanguageService } from '@fcom/ui-translate';
import { RootPaths } from '@fcom/core/constants';
import {
  ButtonSize,
  ButtonTheme,
  ButtonType,
  IconButtonSize,
  IconButtonTheme,
  IconPosition,
} from '@fcom/ui-components';

@Component({
  selector: 'fin-site-search-header-widget-starter',
  templateUrl: 'site-search-header-widget-starter.component.html',
  styleUrls: ['site-search-header-widget-starter.component.scss'],
  standalone: false,
})
export class SiteSearchHeaderWidgetStarterComponent implements OnInit {
  private languageService = inject(LanguageService);
  private formBuilder = inject(UntypedFormBuilder);
  private router = inject(Router);

  readonly SvgLibraryIcon = SvgLibraryIcon;
  readonly IconPosition = IconPosition;
  readonly ButtonTheme = ButtonTheme;
  readonly ButtonSize = ButtonSize;
  readonly ButtonType = ButtonType;
  readonly IconButtonTheme = IconButtonTheme;
  readonly IconButtonSize = IconButtonSize;

  @ViewChild('headerQueryField', { static: false })
  headerQueryField: ElementRef;

  @Input()
  expandable = false;

  @Input()
  enableNewLanguageSelector = false;

  @Input()
  searchButtonIconOnly = false;

  @Input() context: string;

  @Output()
  searchGtmEvent: EventEmitter<Event> = new EventEmitter<Event>();

  query = '';
  siteSearchPath = '';
  searchForm: UntypedFormGroup;
  inputExpanded: boolean;

  constructor() {
    this.siteSearchPath = `/${[this.languageService.langValue, RootPaths.SITE_SEARCH_ROOT].filter(Boolean).join('/')}`;
  }

  ngOnInit(): void {
    this.searchForm = this.formBuilder.group({
      searchKey: [],
    });
    this.inputExpanded = !this.expandable;
  }

  expandSearch(): void {
    this.inputExpanded = true;
    this.headerQueryField.nativeElement.focus();
    this.searchGtmEvent.emit();
  }

  collapseSearch(): void {
    this.inputExpanded = false;
  }

  onSubmit(): void {
    const q = this.searchForm.get('searchKey').value;
    this.triggerSearch(q);
  }

  onBlur(): void {
    if (this.expandable && !this.searchForm.get('searchKey').value) {
      this.collapseSearch();
    }
  }

  triggerSearch(query: string): void {
    const q = query ? `?query=${query}` : '';
    this.router.navigateByUrl(`${this.languageService.langValue}/search${q}`);

    this.collapseSearch();
    this.searchForm.reset(this.searchForm.get('searchKey'));
  }
}
